import { render, staticRenderFns } from "./ToStudy.vue?vue&type=template&id=f70a38d2&scoped=true&"
import script from "./ToStudy.vue?vue&type=script&lang=js&"
export * from "./ToStudy.vue?vue&type=script&lang=js&"
import style0 from "./ToStudy.vue?vue&type=style&index=0&id=f70a38d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70a38d2",
  null
  
)

export default component.exports